var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIgWhitebk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FCFCF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 26.7142C25.4991 26.7142 26.7143 25.499 26.7143 23.9999C26.7143 22.5009 25.4991 21.2856 24 21.2856C22.5009 21.2856 21.2857 22.5009 21.2857 23.9999C21.2857 25.499 22.5009 26.7142 24 26.7142Z",
    fill: "#22252D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3921 15.8572H20.6064C17.9878 15.8572 15.8571 17.9886 15.8571 20.6079V27.3936C15.8571 30.0122 17.9884 32.1429 20.6077 32.1429H27.3934C30.0121 32.1429 32.1428 30.0115 32.1428 27.3922V20.6065C32.1428 17.9879 30.0114 15.8572 27.3921 15.8572ZM23.9999 28.0715C21.7545 28.0715 19.9285 26.2454 19.9285 24C19.9285 21.7546 21.7545 19.9286 23.9999 19.9286C26.2453 19.9286 28.0713 21.7546 28.0713 24C28.0713 26.2454 26.2453 28.0715 23.9999 28.0715ZM28.7499 19.9286C28.3753 19.9286 28.0713 19.6246 28.0713 19.25C28.0713 18.8755 28.3753 18.5715 28.7499 18.5715C29.1245 18.5715 29.4285 18.8755 29.4285 19.25C29.4285 19.6246 29.1245 19.9286 28.7499 19.9286Z",
    fill: "#22252D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(15.4285 15.4287)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgWhitebk);
export default __webpack_public_path__ + "static/media/ig_whitebk.06089495dd6979569558eb7fb3d51383.svg";
export { ForwardRef as ReactComponent };